import { QuestionTitle, type IQuestionTitle } from './question-title';

export interface IQuestionSubtitle extends IQuestionTitle {}

export class QuestionSubtitle
  extends QuestionTitle
  implements IQuestionSubtitle
{
  constructor(options: IQuestionSubtitle) {
    super(options);
    this.elementType = 'subtitle';
    this.size = 0;
  }
}
